import { motion } from "framer-motion";
import { TRANSPARENCY_FIELDS } from "../lib/materials";
import { fadeUp, viewportOnce, stagger } from "../lib/motion";

const TransparencyGrid = () => (
    <section
        id="transparency"
        data-testid="transparency-section"
        className="relative bg-ink py-24 lg:py-36"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="flex items-center gap-6"
            >
                <p className="font-mono text-[13px] tracking-[0.3em] text-mist">
                    TRANSPARENCY
                </p>
                <span className="h-px flex-1 bg-white/10" />
                <p className="font-mono text-[13px] tracking-[0.3em] text-cad">
                    6 FIELDS
                </p>
            </motion.div>

            <motion.h2
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                data-testid="transparency-headline"
                className="mt-12 max-w-4xl font-display text-4xl font-semibold leading-[1.1] text-white md:text-6xl"
            >
                WHAT A VERIFIED PRICE INCLUDES
                <span className="text-accent">.</span>
            </motion.h2>

            <motion.div
                variants={stagger}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="mt-16 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-3"
            >
                {TRANSPARENCY_FIELDS.map((f) => (
                    <motion.div
                        key={f.n}
                        variants={fadeUp}
                        data-testid={`transparency-field-${f.n
                            .toLowerCase()
                            .replace(".", "-")}`}
                        className="border-t border-white/15 pt-6"
                    >
                        <p className="font-mono text-[13px] tracking-[0.3em] text-accent">
                            {f.n}
                        </p>
                        <h3 className="mt-5 font-display text-lg font-semibold tracking-wide text-white">
                            {f.title}
                        </h3>
                        <p className="mt-3 text-sm leading-relaxed text-mist">
                            {f.copy}
                        </p>
                    </motion.div>
                ))}
            </motion.div>
        </div>
    </section>
);

export default TransparencyGrid;
